import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_GESCON_SEF_URL}${process.env.VUE_APP_API_PATH}`

export default {
    ListarConvenios() {
        return axiosJwt
            .get(`${api}/gescon/fornecedor/convenio/ListarConvenios`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    ObterConvenioPorId(id) {
        return axiosJwt
            .get(`${api}/gescon/fornecedor/convenio/ObterConvenioPorId/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    InserirLicitacao(licitacao) {
        return axiosJwt.post(`${api}/gescon/fornecedor/convenio/InserirLicitacao`, licitacao)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },
    AlterarLicitacao(licitacao) {
        return axiosJwt.post(`${api}/gescon/fornecedor/convenio/AlterarLicitacao`, licitacao)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },
    ExcluirLicitacao(id) {
        return axiosJwt
            .get(`${api}/gescon/fornecedor/convenio/ExcluirLicitacao/${id}`)
            .catch(error => {
                return errorHandler(error)
            })
    },
    ListarPrestacoesContas(idConvenio) {
        return axiosJwt
            .get(`${api}/gescon/fornecedor/convenio/ListarPrestacoesMensais/${idConvenio}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    EnviarPrestacaoMensal(idPrestacaoMensal) {
        return axiosJwt.post(`${api}/gescon/fornecedor/convenio/enviarprestacaomensal/${idPrestacaoMensal}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    ObterPrestacaoMensal(id) {
        return axiosJwt
            .get(`${api}/gescon/fornecedor/convenio/ObterPrestacaoMensal/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    InserirPrestacaoMensal(prestacao) {
        return axiosJwt.post(`${api}/gescon/fornecedor/convenio/InserirPrestacaoMensal`, prestacao)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    ExcluirPrestacaoMensal(id) {
        return axiosJwt
            .get(`${api}/gescon/fornecedor/convenio/ExcluirPrestacaoMensal/${id}`)
            .catch(error => {
                return errorHandler(error)
            })
    },

    ListarPrestacoesFinais(idPrestacaoMensal) {
        return axiosJwt
            .get(`${api}/gescon/fornecedor/convenio/ListarPrestacoesFinais/${idPrestacaoMensal}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    ListarAcoes(idConvenio) {
        return axiosJwt
            .get(`${api}/gescon/fornecedor/convenio/ListarAcoes/${idConvenio}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    ListarNaturesasPorAcoes(idConvenio, idAcao) {
        return axiosJwt
            .get(`${api}/gescon/fornecedor/convenio/ListarNaturesasPorAcoes/${idConvenio}/${idAcao}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    InserirPrestacaoFinal(prestacao) {
        return axiosJwt.post(`${api}/gescon/fornecedor/convenio/InserirPrestacaoFinal`, prestacao)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    AtualizarPrestacaoFinal(prestacao) {
        return axiosJwt.post(`${api}/gescon/fornecedor/convenio/AtualizarPrestacaoFinal`, prestacao)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    ExcluirPrestacaoFinal(id) {
        return axiosJwt
            .get(`${api}/gescon/fornecedor/convenio/ExcluirPrestacaoFinal/${id}`)
            .catch(error => {
                return errorHandler(error)
            })
    },

    ListarDocumentosPrestacaoFinal(idPrestacaoFinal) {
        return axiosJwt
            .get(`${api}/gescon/fornecedor/convenio/ListarDocumentosPrestacoesFinais/${idPrestacaoFinal}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTiposDocumentos() {
        return axiosJwt
            .get(`${api}/gescon/fornecedor/convenio/ListarTiposDocumentos`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    ObterImpostos() {
        return axiosJwt
            .get(`${api}/gescon/fornecedor/convenio/impostos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirDocumentosPrestacaoFinal(documento) {
        const formData = new FormData()
        formData.append('id_Documento', documento.idDocumento)
        formData.append('id_Convenio', documento.idConvenio)
        formData.append('idPrestacaoContasFinal', documento.idPrestacaoContasFinal)
        formData.append('id_TipoDocumento', documento.idTipoDocumento)
        formData.append('vcDescricaoDocumento', documento.vcDescricaoDocumento)
        formData.append('vcNomeArquivo', documento.vcNomeArquivo)
        formData.append('Arquivo', documento.arquivo)

        return axiosJwt.post(`${api}/gescon/fornecedor/convenio/InserirDocumentoConvenio`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    atualizarDocumentoPrestacaoFinal(documento) {
        const formData = new FormData()
        formData.append('id_Documento', documento.idDocumento)
        formData.append('id_Convenio', documento.idConvenio)
        formData.append('idPrestacaoContasFinal', documento.idPrestacaoContasFinal)
        formData.append('id_TipoDocumento', documento.idTipoDocumento)
        formData.append('vcDescricaoDocumento', documento.vcDescricaoDocumento)
        formData.append('vcNomeArquivo', documento.vcNomeArquivo)
        formData.append('arquivo', documento.arquivo)

        return axiosJwt.post(`${api}/gescon/fornecedor/convenio/atualizardocumentoconvenio`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    ExcluirDocumentoConvenio(id) {
        return axiosJwt
            .get(`${api}/gescon/fornecedor/convenio/ExcluirDocumentoConvenio/${id}`)
            .catch(error => {
                return errorHandler(error)
            })
    },

    downloadDocumento(id) {
        return axiosJwt
            .get(
                `${api}/gescon/fornecedor/convenio/DownloadDocumentoPorId/${id}`,
                {
                    responseType: 'blob'
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterRelatorio(idConvenio, relatorio) {
        return axiosJwt
            .get(`${api}/gescon/fornecedor/convenio/${idConvenio}/relatorios/${relatorio}`, { responseType: 'blob' })
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },
    obterRelatorioParaAssinatura(idConvenio, relatorio) {
        return axiosJwt
            .get(`${api}/gescon/fornecedor/convenio/${idConvenio}/relatorios/${relatorio}`, { responseType: 'blob' })
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },
    EnviarDocumentoParaAssinador(idConvenio, relatorio) {
        return axiosJwt
            .get(`${api}/gescon/fornecedor/convenio/${idConvenio}/EnviarDocumentoParaAssinadorEletronico/${relatorio}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    ObterAcoesPlanoTrabalho(idConvenio) {
        return axiosJwt
            .get(`${api}/gescon/fornecedor/convenio/obteracoesplanotrabalho/${idConvenio}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirAcaoPlanoTrabalho(acao) {
        return axiosJwt.post(`${api}/gescon/fornecedor/convenio/inseriracaoplanotrabalho`, acao)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    cancelarAcaoPlanoTrabalho(id) {
        return axiosJwt
            .get(`${api}/gescon/fornecedor/convenio/cancelaracaoplanotrabalho/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    alterarAcaoPlanoTrabalho(acao) {
        return axiosJwt.post(`${api}/gescon/fornecedor/convenio/alteraracaoplanotrabalho`, acao)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterEventosPorAcao(id) {
        return axiosJwt
            .get(`${api}/gescon/fornecedor/convenio/acaoplanotrabalho/${id}/eventos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    // obterConsultoriasPorAcao(id) {
    //     return axiosJwt
    //         .get(`${api}/gescon/fornecedor/convenio/acaoplanotrabalho/${id}/consultorias`)
    //         .then(response => {
    //             return response.data
    //         })
    //         .catch(error => {
    //             return errorHandler(error)
    //         })
    // },

    cancelarEvento(id) {
        return axiosJwt
            .get(`${api}/gescon/fornecedor/convenio/cancelarevento/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirEvento(evento) {
        return axiosJwt.post(`${api}/gescon/fornecedor/convenio/inserirevento`, evento)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    alterarEvento(evento) {
        return axiosJwt.post(`${api}/gescon/fornecedor/convenio/alterarevento`, evento)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterDocumentosEvento(idEvento) {
        return axiosJwt
            .get(`${api}/gescon/fornecedor/convenio/obterdocumentosevento/${idEvento}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirDocumentoEvento(documento) {
        const formData = new FormData()
        formData.append('idEvento', documento.idEvento)
        formData.append('vcNomeArquivo', documento.vcNomeArquivo)
        formData.append('arquivo', documento.arquivo)
        formData.append('descricaoArquivo', documento.descricaoArquivo)
        return axiosJwt.post(`${api}/gescon/fornecedor/convenio/inserirdocumentoevento`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    excluirDocumentoEvento(idDocumentoEvento) {
        return axiosJwt
            .get(`${api}/gescon/fornecedor/convenio/excluirdocumentoevento/${idDocumentoEvento}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    downloadDocumentoEvento(idEvento, idDocumento) {
        return axiosJwt
            .get(`${api}/gescon/fornecedor/convenio/downloaddocumentoevento/${idEvento}/${idDocumento}`, { responseType: 'blob' })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    obterDocumentosLicitacao(idLicitacao) {
        return axiosJwt
            .get(`${api}/gescon/fornecedor/convenio/obterdocumentosLicitacao/${idLicitacao}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    inserirDocumentosLicitacao(documento) {
        const formData = new FormData()
        formData.append('idLicitacao', documento.idLicitacao)
        formData.append('vcNomeArquivo', documento.vcNomeArquivo)
        formData.append('arquivo', documento.arquivo)
        formData.append('descricaoArquivo', documento.descricaoArquivo)

        return axiosJwt.post(`${api}/gescon/fornecedor/convenio/InserirDocumentoLicitacao`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },
    excluirDocumentoLicitacao(idDocumentoLicitacao) {
        return axiosJwt
            .get(`${api}/gescon/fornecedor/convenio/excluirdocumentolicitacao/${idDocumentoLicitacao}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    downloadDocumentoLicitacao(idLicitacao, idDocumento) {
        return axiosJwt
            .get(`${api}/gescon/fornecedor/convenio/downloaddocumentolicitacao/${idLicitacao}/${idDocumento}`, { responseType: 'blob' })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    cancelarMeta(id) {
        return axiosJwt
            .get(`${api}/gescon/fornecedor/convenio/cancelarmeta/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirMeta(meta) {
        return axiosJwt.post(`${api}/gescon/fornecedor/convenio/inserirmeta`, meta)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterTiposInstrumento() {
        return axiosJwt
            .get(`${api}/gescon/fornecedor/convenio/obtertiposinstrumento`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterGestores() {
        return axiosJwt
            .get(`${api}/gescon/fornecedor/convenio/gestores`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterUnidades() {
        return axiosJwt
            .get(`${api}/gescon/fornecedor/convenio/unidades`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
}
